module.exports = __webpack_public_path__ + "static/img/bnt1.63a3f8d1.png";